import React from 'react';
import PageHeader from '../common/PageHeader';
import PageFilter from '../common/PageFilter';
import { overTimeConfig, employeeOvertimeColumnList } from '../../constants/MockData';
import { apiBatchRequest, apiPut } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import GridTable from '../common/Table/Table';
import EditIcon from '@material-ui/icons/Edit';
import commonLabels from '../../constants/messageConstants';
import { ShowToast, toastType } from '../../utils/toast-service';
import { cloneDeep, getCurrentPayCycle, getCurrentPayCycleStartDate, isDateInCurrentPayCycle, isGridFormValid, IsSectionVisible, UpdateColumnWithConfiguration, getCurrentPayCycleStartDateByDate, getCurrentPayCycleEndDateByDate } from '../../utils/helper';
import store from '../../store/appStore';
import { controlType } from '../../constants/common';
import DateFnsUtils from '@date-io/date-fns';
import CancelIcon from '@material-ui/icons/Cancel';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import './index.less';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import {
  Button,
  Grid,
  IconButton,
  TextField,
  Tooltip
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import { DateFormat, SECTIONS } from '../../constants/appConstants';
import _ from 'lodash';
import ResetIcon from '@material-ui/icons/RestorePageOutlined';
import SearchIcon from '@material-ui/icons/Search';
import ViewIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilitySharpIcon from '@material-ui/icons/VisibilitySharp';

class EmployeeOvertimeAttendance extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = {
      employeeOvertimeData: [],
      propertyMasterData: [],
      marketMasterData: [],
      payCycleData: [],
      configuration: [],
      otData: [],
      periodStartDate: null,
      periodEndDate: null,
      employeeName: null,
      payCycle: null,
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: {},
      isPopupOpen: false,
      confirmationMessage: '',
      isInCurrentPayCycle: false,
      employeeOvertimeColumn: employeeOvertimeColumnList,
      originalPayCycleData: [],
      employeeMasterData: [],
      employeeId: 0,
      employeeOtData: [],
      searched: false,
      showSubmitAndClear: false,
      totalDays: 0,
      otSumTotal: 0,
      regularSum: 0,
      defaultSelectedData: [],
      selectedData: [],
      isForDelete: false,
      inEditMode: false,
      isClosed: false

    };
  }

  componentDidMount () {
    const selectedData = [];
    // const date = getCurrentPayCycle();
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData'
      },
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: 'propertyMasterData'
      },
      // {
      //   url: API_URL.Report.GetPayCycle,
      //   key: 'payCycleData'
      // },
      {
        url: API_URL.Employee.GetEmployeeOvertimeDetail, // + '?periodStartDate=' + date[1] + '&periodEndDate=' + date[0],
        key: 'employeeOvertimeData'
      },
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeMasterData'
      },
      {
        url: API_URL.Employee.GetUltiProOvertimeScheduleDetails + '?year=' + moment().year(),
        key: 'payCycleData'
      }
    ])
      .then(({ marketMasterData, propertyMasterData, employeeOvertimeData, employeeMasterData, payCycleData }) => {
        this._asyncRequest = null;
        if (employeeOvertimeData.success !== true) {
          ShowToast(commonLabels.somethingWrong, toastType.ERROR, 5000, 500, 'Server error');
        }
        selectedData.push(
          {
            key: 'payCycle',
            selected: (payCycleData.data)[0] // .find(x => x.payCycle === (date[1] + '-' + date[0])) || {})
          }

        );
        selectedData.push();
        const otData = [];
        // const showForm = (employeeOvertimeData?.data.length > 0) === false;
        const isAllowedToEdit = (employeeOvertimeData?.data || [])[0]?.isEditable || true;
        marketMasterData.data = _.orderBy(marketMasterData.data, 'employeeName', ['asc']);
        propertyMasterData.data = _.orderBy(propertyMasterData.data, 'employeeName', ['asc']);
        marketMasterData.data = _.orderBy(marketMasterData.data, 'employeeName', ['asc']);

        payCycleData.data.unshift({ payCycle: '' });
        const isClosed = payCycleData.data?.length > 0 ? (payCycleData.data)[0]?.isClosed : false;
        this.setState({
          isClosed: isClosed,
          inEditMode: isClosed === false ? false : isClosed,
          employeeName: (((store.getState() || {}).auth || {}).account || {}).name || '',
          payCycle: (payCycleData.data[1]), // .find(x => x.payCycle === (date[1] + '-' + date[0])) || {}),
          employeeOvertimeData: [...(employeeOvertimeData.data || [])],
          marketMasterData: marketMasterData.data || [],
          propertyMasterData: propertyMasterData.data,
          payCycleData: payCycleData.data || [],
          originalPayCycleData: payCycleData.data || [],
          configuration: employeeOvertimeData.config || [],
          otData: otData.filter(x => x.otHours > 0 || x.additionalRegHours > 0),
          periodStartDate: moment(payCycleData.data[1].startDate).format('MM/DD/YYYY'),
          periodEndDate: moment(payCycleData.data[1].endDate).format('MM/DD/YYYY'),
          isInCurrentPayCycle: true,
          employeeMasterData: employeeMasterData.data || [],
          originalOtData: [],
          showSubmitAndClear: false,
          totalDays: 0,
          otSumTotal: 0,
          regularSum: 0,
          selectedData: selectedData || [],
          defaultSelectedData: [...selectedData],
          isAllowedToEdit
          // showForm
        });
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  EditRecord = (cellInfo) => {
    const editMode = true;
    const employeeOvertimeColumn = cloneDeep(employeeOvertimeColumnList);
    employeeOvertimeColumn.map(x => {
      if (x.key === 'otDate') { x.minDate = getCurrentPayCycleStartDate(); }
      return x;
    });
    const { selectedData, employeeMasterData, payCycleData, inEditMode } = this.state;
    if (inEditMode) {
      ShowToast('You are already in edit mode!', toastType.WARNING, 5000, 500);
      return;
    }

    if (selectedData && selectedData.find(x => x.key === 'employeeName') === undefined) {
      selectedData.push({
        multiple: false,
        type: controlType.DropDown,
        source: employeeMasterData,
        key: 'employeeName',
        placeholder: 'Search Employee',
        title: 'Employee',
        disableClearable: false
      });
    }
    selectedData.forEach(
      x => {
        if (x.key === 'employeeName') {
          x.selected = employeeMasterData.find(em => em.employeeName === cellInfo.employeeName);
        }
        if (x.key === 'payCycle') {
          x.selected = payCycleData.find(em =>
            new Date(moment(em.startDate).format('MM/DD/YYYY')) <= new Date(moment(cellInfo.otDate).format('MM/DD/YYYY')) &&
            new Date(moment(cellInfo.otDate).format('MM/DD/YYYY')) <= new Date(moment(em.endDate).format('MM/DD/YYYY')));
        }
      }
    );

    this.setState({
      selectedData,
      inEditMode: editMode,
      submittedData: false
    }, () => { this.onFilterChange(selectedData, true); });
  }

  isValidForm = () => {
    let IsValid = true;
    const { updateData, employeeOvertimeColumn } = this.state;
    employeeOvertimeColumn.forEach((ele) => {
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    this.setState({ employeeOvertimeColumn }, this.forceUpdate());
    return IsValid;
  };

  saveUpdatedRecord = () => {
    if (!this.isValidForm()) { return false; } else {
      const otData = [];
      const data = this.state.updateData;
      data.hours = parseFloat(data.otHours);
      data.otHours = parseFloat(data.otHours);
      // data.regHours = parseFloat(data.regHours);
      data.additionalRegHours = parseFloat(data.additionalRegHours);
      data.otDate = moment(data.otDate).format(
        'YYYY/MM/DD'
      );
      data.payDate = moment(data.payDate).format('YYYY/MM/DD');
      data.approvalStatusId = 3;
      data.statusId = 1;
      otData.push(data);
      this.SaveOvertimeAttendance(otData, 2);
    }
  }

  cancelMode = () => {
    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined
    }, () => { this.forceUpdate(); });
  }

  DeleteRecord = (cellInfo) => {
    this.setState({
      isPopupOpen: true,
      confirmationMessage: 'Deleting this record will delete whole overtime attendance sheet. Do you still want to continue?',
      updateData: cellInfo,
      isForDelete: true
      // submittedData: false
    }, () => { this.forceUpdate(); });
  }

  onPopupClickHandle = (isValid) => {
    if (isValid) {
      const otDetails = this.state.employeeOvertimeData;
      const otData = [];
      const data = this.state.updateData;
      data.statusId = 11;
      // otData.push(data);
      otDetails.forEach(x => {
        if (x.employeeId === data.employeeId) {
          x.statusId = 11;
          otData.push(x);
        }
      });
      this.setState({
        isPopupOpen: false,
        confirmationMessage: '',
        submittedData: false
      }, () => {
        this.SaveOvertimeAttendance(otData, 1);
      });
    } else {
      this.setState({
        updateData: undefined,
        isPopupOpen: false,
        confirmationMessage: ''
      });
    }
  }

  renderActionColumn = (cellInfo) => {
    return (
      <>
          {this.state.selectedEditRowId !== undefined && cellInfo.employeeOvertimeId === this.state.selectedEditRowId.value
            ? (
            <>
              <Tooltip title="Save Record">
                <IconButton aria-label={'refreshData'} size="small" onClick={() => { }}>
                  <SaveIcon fontSize="small" size="small" onClick={this.saveUpdatedRecord} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Cancel">
                <IconButton aria-label={'refreshData'} size="small" onClick={this.cancelMode}>
                  <CancelIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            </>
              )
            : <>{cellInfo?.isEditable === false
              ? (
              <Tooltip title="View Record">
            <IconButton aria-label={'refreshData'} size="small" onClick={() => {
              if (this.state.isInAddMode === true || this.state.selectedEditRowId !== undefined) {
                ShowToast('You can add/Edit one row at a time!', toastType.WARNING, 5000, 500);
                return false;
              } else {
                this.EditRecord(cellInfo);
              }
            }}>
              <VisibilitySharpIcon fontSize="small" size="small" />
            </IconButton>
          </Tooltip>)
              : IsSectionVisible(SECTIONS.OVERTIMEATTANDENCESHEET, 0, SECTIONS.ADD_EDIT) && this.state.isClosed === false && (
            <>
            <Tooltip title="Edit Record">
            <IconButton aria-label={'refreshData'} size="small" onClick={() => {
              if (this.state.isInAddMode === true || this.state.selectedEditRowId !== undefined) {
                ShowToast('You can add/Edit one row at a time!', toastType.WARNING, 5000, 500);
                return false;
              } else {
                this.EditRecord(cellInfo);
              }
            }}>
              <EditIcon fontSize="small" size="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete Record">
            <IconButton
            aria-label={'refreshData'}
            size="small"
            onClick={() => {
              this.DeleteRecord(cellInfo);
            }}
            >
            <DeleteIcon fontSize="small" size="small" />
            </IconButton>
        </Tooltip>
          </>)
            }</> }
      </>
    );
  };

  getlength (number) {
    return number.toString().length;
  }

   getFormattedData = (value) => {
     const length = this.getlength(value);
     const num = 9;
     const noOfZeroes = num - length;
     let zeroString = '';
     for (let i = 0; i < noOfZeroes; i++) {
       zeroString = zeroString.concat('0');
     }
     return zeroString + value.toString();
   };

   onChangeValues = (val, obj, ind) => {
     const {
       otData, originalOtData, hoursOtData, ultiproAddSum,
       ultiproOtSum
     } = this.state;
     const currentObj = otData[ind];
     const currentOtReg = hoursOtData?.dates?.filter(x => x.key === currentObj.otDate);
     let originalOtRowHours = 0;
     let originaladdRegRowHours = 0;
     currentOtReg.forEach(x => {
       originalOtRowHours += x.totalOtHours;
       originaladdRegRowHours += x.additionalRegHoursSum;
     });
     if (obj.key === 'otHours' || obj.key === 'additionalRegHours') {
       otData[ind][obj.key] = val;
     }
     let isSplittedObj = false;
     const splittedObj = otData.filter(x => x.otDate === currentObj.otDate);
     isSplittedObj = splittedObj.length > 1;
     let totalOtHours = 0;
     let totalRegHours = 0;
     splittedObj.forEach(x => {
       totalOtHours += (parseFloat(x.otHours) || 0);
       totalRegHours += (parseFloat(x.additionalRegHours) || 0);
     });
     if (obj.isRequired === false) {
       obj.isInErrorState = false;
       obj.errorMessage = '';
     }

     if (obj.idField !== undefined) {
       otData[ind][obj.idField] = val[obj.idField];
     }
     if (obj.resetValue !== undefined && obj.resetValue?.length > 0) {
       obj.resetValue.forEach(x => {
         otData[ind][x] = '';
       });
     }
     let errorObj = {
       isInErrorState: false,
       errorMessage: ''
     };
     if (obj.dataFormat === 'DecimalNumber') {
       if (obj.key === 'otHours') {
         errorObj = this.validateData(val, obj, originalOtRowHours, totalOtHours);
       } else if (obj.key === 'additionalRegHours') {
         errorObj = this.validateData(val, obj, originaladdRegRowHours, totalRegHours);
       }
     } else if (obj.dataFormat === 'Text') {
       if (obj.key === 'propertyName') {
         if (splittedObj.length > 1) {
           // if (splittedObj[0]?.propertyName?.propertyId === val?.propertyId) {
           //   errorObj.isInErrorState = true;
           //   errorObj.errorMessage = 'Duplicate property field selected for same date';
           // }
           splittedObj.forEach(x => {
             if (x?.propertyName?.propertyId === val?.propertyId) {
               errorObj.isInErrorState = true;
               errorObj.errorMessage = 'Duplicate property field selected for same date';
             }
           });
         }
       }
     } else {
       errorObj = this.validateData(val, obj);
     }
     // });
     otData[ind][obj.key + 'errorMessage'] = errorObj === null ? '' : errorObj?.errorMessage;
     otData[ind]['Is' + obj.key] = errorObj === null ? false : errorObj?.isInErrorState;
     otData[ind].isInErrorState = errorObj === null ? false : errorObj?.isInErrorState;
     otData[ind][obj.key] = val;
     if (obj.key === 'otHours' || obj.key === 'additionalRegHours') {
       if (otData[ind]?.isInErrorState !== true) {
         otData.forEach(x => {
           if (x.otDate === currentObj.otDate) {
             x['Is' + obj.key] = false;
             x.isInErrorState = false;
             x[obj.key + 'errorMessage'] = '';
           }
         });
       }
     }
     if (obj.key === 'propertyName') {
       if (errorObj.isInErrorState === false) {
         otData.forEach(x => {
           x.propertyNameerrorMessage = '';
           x.IspropertyName = false;
         });
       }
     }
     this.setState({ otData }, () => { this.forceUpdate(); });
   }

  isNumberKey = (evt) => {
    if (evt.target.value === '') {
      return true;
    } else {
      const numericInput = new RegExp(
        '^\\s*((\\d+(\\.\\d{0,2})?)|((\\d*(\\.\\d{1,2}))))\\s*$'
      ); // '/^[0-9\b]+$/');
      return numericInput.test(evt.target.value);
    }
  }

    validateData = (value, obj, rowOtReg = 0, enteredValue = 0) => {
      const errorObj = {
        isInErrorState: false,
        errorMessage: ''
      };
      if (
        obj.isRequired === true &&
            (value === null || value === undefined || value === '')
      ) {
        errorObj.isInErrorState = true;
        if (obj.dataFormat === 'Date') {
          errorObj.errorMessage =
                (obj.displayName) + ' field value is required and should be in MM/DD/YYYY format.';
        } else {
          errorObj.errorMessage =
                (obj.displayName) + ' field value is required.';
        }
      } else if (obj.dataFormat === 'DecimalNumber') {
        // if ((parseFloat(value) || 0) === 0) {
        //   errorObj.isInErrorState = true;
        //   errorObj.errorMessage = obj.displayName + ' field value can not be zero';
        // } else
        if (obj.isInErrorState) {
          errorObj.isInErrorState = true;
          errorObj.errorMessage = obj.errorMessage;
          // errorObj.errorMessage =
          //   'Given ' + (obj.displayName) + ' value is not valid.';
        } else {
          const numericInput = new RegExp('^\\s*((\\d+(\\.\\d{0,2})?)|((\\d*(\\.\\d{1,2}))))\\s*$'); // '/^[0-9\b]+$/');
          errorObj.isInErrorState = numericInput.test(value);
          if (obj.key === 'additionalRegHours') {
            if (parseFloat(value) > parseFloat(this.state.otReg)) {
              errorObj.isInErrorState = false;
            }
            // else if (parseFloat(value) > parseFloat(rowOtReg)) {
            //   errorObj.isInErrorState = false;
            // }
            // else if (parseFloat(value) + parseFloat(enteredValue) > parseFloat(rowOtReg)) {
            //   errorObj.isInErrorState = false;
            // }
            // else if (parseFloat(value) === 0) {
            //   errorObj.isInErrorState = false;
            // }
          } else {
            if (parseFloat(value) > parseFloat(this.state.otHrs)) {
              errorObj.isInErrorState = false;
            }
            // else if (parseFloat(value) > parseFloat(rowOtReg)) {
            //   errorObj.isInErrorState = false;
            // }
            // else if (parseFloat(value) + parseFloat(enteredValue) > parseFloat(rowOtReg)) {
            //   errorObj.isInErrorState = false;
            // }
            // else if (parseFloat(value) === 0) {
            //   errorObj.isInErrorState = false;
            // }
          }

          // else if ((parseFloat(value) + parseFloat(totalOtHours1)) > this.state.otSumTotal) {
          //   errorObj.isInErrorState = false;
          // }
          if (!errorObj.isInErrorState) {
            errorObj.isInErrorState = true;
            if (obj.key === 'otHours') {
              // if (value === '') {
              //   value = 0;
              // }
              if (parseFloat(value) > this.state.otHrs) {
                errorObj.errorMessage =
                (obj.displayName) + ` field value cannot exceed ${'UltiPro overtime hours ' + this.state?.otHrs?.toString()}.`;
              } else if (parseFloat(value) > parseFloat(rowOtReg)) {
                errorObj.errorMessage =
                (obj.displayName) + ` field value  cannot exceed ${'UltiPro row overtime hours ' + rowOtReg?.toString()}.`;
              } else if (parseFloat(enteredValue) > parseFloat(rowOtReg)) {
                errorObj.errorMessage =
                (obj.displayName) + ` field value  cannot exceed ${'UltiPro row overtime hours ' + rowOtReg?.toString() + ' for this date'}.`;
              }
              // else if (value?.length <= 0) {
              //   errorObj.errorMessage =
              //   (obj.displayName) + ' field value is required.';
              // }
              // else if (parseFloat(value) === 0) {
              //   errorObj.errorMessage =
              //   (obj.displayName) + ` field value  cannot be ${'0'}.`;
              // }
              else {
                errorObj.isInErrorState = false;
              }
            } else if (obj.key === 'additionalRegHours') {
              if (parseFloat(value) > this.state.otReg) {
                errorObj.errorMessage =
                (obj.displayName) + ` field value cannot exceed ${'UltiPro Additional regular hours ' + this.state.otReg.toString()}.`;
              } else if (parseFloat(value) > parseFloat(rowOtReg)) {
                errorObj.errorMessage =
                (obj.displayName) + ` field value cannot exceed  ${'UltiPro row Additional regular hours ' + rowOtReg?.toString()}.`;
              } else if (parseFloat(enteredValue) > parseFloat(rowOtReg)) {
                errorObj.errorMessage =
                (obj.displayName) + ` field value  cannot exceed ${'UltiPro row overtime hours ' + rowOtReg?.toString() + ' for this date'}.`;
              }
              // else if (value?.length <= 0) {
              //   errorObj.errorMessage =
              //   (obj.displayName) + ' field value is required.';
              // }
              else if (parseFloat(value) === 0) {
                errorObj.errorMessage =
                (obj.displayName) + ` field value  cannot be ${'0'}.`;
              } else {
                errorObj.isInErrorState = false;
              }
            }
          } else {
            errorObj.isInErrorState = false;
            errorObj.errorMessage = '';
          }
        }
      } else if (obj.dataFormat === 'Date') {
        errorObj.isInErrorState = (value ? moment(value).format('MM/DD/YYYY') !== 'Invalid Date' : false);
        if (!errorObj.isInErrorState) {
          errorObj.isInErrorState = true;
          errorObj.errorMessage =
              (obj.displayName) + ' field value is not valid.';
        } else {
          errorObj.isInErrorState = (obj.minDate ? new Date(value).getTime() >= new Date(obj.minDate).getTime() : true);
          if (errorObj.isInErrorState === false) {
            errorObj.isInErrorState = true;
            errorObj.errorMessage = 'Please enter valid date in field.';
          } else {
            errorObj.isInErrorState = false;
            errorObj.errorMessage = '';
          }
        }
      }
      return errorObj;
    }

    renderForm = (configuration, ind, dropDownSource, data) => {
      return configuration
        .filter((x) => x.isVisible === true)
        .map((obj) => (
          this.renderField(obj, ind, dropDownSource, data, configuration)
        ));
    }

    AddNewRow = (formFields, ind) => {
      const { otData, periodStartDate, periodEndDate } = this.state;
      otData.splice(ind + 1, 0, {
        employeeOvertimeId: otData[ind]?.employeeId,
        approvalStatusId: 3,
        statusId: 1,
        employeeEmail: null,
        periodStartDate: periodStartDate,
        periodEndDate: periodEndDate,
        otHours: 0,
        marketId: otData[ind]?.marketId,
        marketName: otData[ind]?.marketName,
        propertyId: null,
        propertyName: null,
        otDate: otData[ind].otDate,
        comments: '',
        isInErrorState: false,
        additionalRegHours: 0,
        payDate: otData[ind].payDate,
        isReal: false
      });
      this.setState({ otData: otData }, () => { this.forceUpdate(); });
    }

    validateForm = (otData, formFields) => {
      const validateField = ['payDate', 'marketName', 'propertyName', 'otHours', 'additionalRegHours', 'comments'];
      otData.map(ot => {
        ot.isInErrorState = false;
        for (const key in ot) {
          if (validateField.find(x => x === key) !== undefined) {
            const obj = formFields.find(x => x.key === key);
            let errorObj;
            if (obj.key === 'otHours') {
              if (ot.isOtDisabled) {
                errorObj = {
                  isInErrorState: false,
                  errorMessage: ''
                };
              } else {
                errorObj = this.validateData(ot[key], obj, parseFloat(ot.otHours) || 0);
              }
            } else if (obj.key === 'additionalRegHours') {
              if (ot.isAdditionalRegHoursDisabled) {
                errorObj = {
                  isInErrorState: false,
                  errorMessage: ''
                };
              } else {
                errorObj = this.validateData(ot[key], obj, parseFloat(ot.additionalRegHours) || 0);
              }
            } else {
              errorObj = this.validateData(ot[key], obj, parseFloat(ot.additionalRegHours) || 0);
              if (obj.key === 'propertyName' && errorObj.isInErrorState !== true) {
                const splittedObj = otData.filter(x => x.otDate === ot.otDate);
                if ((splittedObj.filter(pro => pro.propertyId === ot.propertyId) || []).length > 1) {
                  errorObj.isInErrorState = true;
                  errorObj.errorMessage = 'Duplicate property field selected for same date';
                }
              }
            }
            ot[obj.key + 'errorMessage'] = errorObj === null ? '' : errorObj?.errorMessage;
            ot['Is' + obj.key] = errorObj === null ? false : errorObj?.isInErrorState;
            ot.isInErrorState = errorObj === null ? false : errorObj?.isInErrorState;
            if (!ot.isInErrorState) {
              ot.isInErrorState = errorObj === null ? false : errorObj?.isInErrorState;
            }
          }
        }

        return ot;
      });
      return otData;
    }

    removeOt = (ind) => {
      const { otData } = this.state;
      otData.splice(ind, 1);
      this.setState({ otData: otData }, () => { this.forceUpdate(); });
    }

    renderField = (obj, ind, dropDownSource, data, configuration) => {
      const { otData, hoursOtData } = this.state;
      const otReg = hoursOtData.dates.find(x => x.key === data.otDate);
      let disabled = false;
      if (obj.disableEdit === true || data.isEditable === false) {
        disabled = true;
      }
      let disableTextField = false;
      const dropDown = dropDownSource.find(x => x.key === obj.key);
      let componentToBeRendered = <></>;
      // if (obj.key === 'otHours') {
      //   // if (this.state.otSumTotal <= 0) {
      //   //   disabled = true;
      //   // }

      //   if (otReg?.totalOtHours === 0) {
      //     disableTextField = true;
      //     data.disableTextField = true;
      //     data.isOtDisabled = true;
      //   }
      // }
      // if (obj.key === 'additionalRegHours') {
      //   // if (this.state.regularSum <= 0) {
      //   //   disabled = true;
      //   // }
      //   if (otReg?.additionalRegHoursSum === 0) {
      //     disableTextField = true;
      //     data.disableTextField = true;
      //     data.isAdditionalRegHoursDisabled = true;
      //   }
      // }
      if (obj.key === 'otDate' || obj.key === 'payDate' || data.isEditable === false) {
        disableTextField = true;
      }
      if (data.isEditable === true || data.isEditable === undefined) {
        if (obj.type === controlType.DatePicker) {
          componentToBeRendered = (
              <div className={`col-xs-${obj.fieldWidth}`}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container>
                      <KeyboardDatePicker
                          minDate = {obj.minDate}
                          disabled={disabled}
                          margin="normal"
                          error={otData[ind]['Is' + obj.key]}
                          helperText={otData[ind][obj.key + 'errorMessage']}
                          id="date-picker-dialog"
                          label={<><span>{obj.displayName}</span> {obj.isRequired ? <span className="error-text">*</span> : ''} </>}
                          format="MM/dd/yyyy"
                          name={obj.key}
                          value={data[obj.key]}
                          onChange={(e) => this.onChangeValues(e, obj, ind)}
                          KeyboardButtonProps={{
                            'aria-label': 'change date'
                          }}
                          className="w-100"
                          InputProps={{ readOnly: true }}
                      />
                      </Grid>
                  </MuiPickersUtilsProvider>
               </div>
          );
        } else if (obj.type === controlType.DropDown) {
          componentToBeRendered = (
              <div className={`col-xs-${obj.fieldWidth}`}>
                   <Autocomplete
                      blurOnSelect
                      id="tags-standard"
                      error={otData[ind]['Is' + obj.key]}
                      helperText={otData[ind][obj.key + 'errorMessage']}
                      onChange={(e, val) => this.onChangeValues(val, obj, ind)}
                      options={obj.filterBy !== undefined && otData[ind][obj.filterBy] > 0 ? dropDown.source.filter(x => x[obj.filterBy] === otData[ind][obj.filterBy]) : dropDown.source}
                      getOptionLabel={(option) => option[dropDown.key]}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label={<><span>{obj.displayName}</span> {obj.isRequired ? <span className="error-text">*</span> : ''} </>}
                          error={otData[ind]['Is' + obj.key]}
                          helperText={otData[ind][obj.key + 'errorMessage']}
                        />
                      )}
                      value = {data[obj.key]}
                    />
               </div>
          );
        } else if (obj.type === controlType.TextBox) {
          componentToBeRendered = (
            <>
            <div className={`col-xs-${obj.fieldWidth}` + (obj.key === 'comments' ? ' comment-container' : '')}>
                  <TextField
                  className={obj.key === 'comments' ? 'comment-text' : ''}
                  // InputProps={inpProps}
                  disabled={disableTextField}
                  error={otData[ind]['Is' + obj.key]}
                  helperText={otData[ind][obj.key + 'errorMessage']}
                  value= {obj.key === 'payDate' ? moment(data[obj.key]).format('MM/DD/YYYY') : data[obj.key]}
                  fullWidth
                  name={obj.key}
                  margin="normal"
                  size="small"
                  color="primary"
                  // label={<><span>{obj.displayName}</span> {(disableTextField || obj.isRequired)} ? <span className="error-text">*</span> : '')} </>}
                  label={<><span>{obj.displayName}</span> {(obj.isRequired || disableTextField) ? (!disableTextField ? <span className="error-text">*</span> : '') : ''} </>}
                  onChange={(e) => {
                    if (obj.key === 'otHours' || obj.key === 'additionalRegHours') {
                      this.isNumberKey(e) && this.onChangeValues(e.target.value, obj, ind);
                    } else { this.onChangeValues(e.target.value, obj, ind); }
                  }}
                  inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', shrink: true }}
                  InputLabelProps={{ shrink: true }}
                  />
               {obj.key === 'comments' && IsSectionVisible(SECTIONS.OVERTIMEATTANDENCESHEET, 0, SECTIONS.ADD_EDIT) && this.state.isClosed === false && <>
               <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          startIcon={ <AddIcon fontSize="small" size="small" />}
                          onClick={() => {
                            this.AddNewRow(configuration, ind);
                          }}
                        >
                          Split
                  </Button>
                  &nbsp;&nbsp;
                  {(otData || []).filter(xd => xd.otDate === data.otDate).length > 1 && IsSectionVisible(SECTIONS.OVERTIMEATTANDENCESHEET, 0, SECTIONS.ADD_EDIT) &&
                  this.state.isClosed === false &&
                  <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          startIcon={ <CancelIcon fontSize="small" size="small" />}
                          onClick={() => {
                            this.removeOt(ind);
                          }}
                        >
                          Remove
                  </Button>}
               </>}
               </div>
          </>

          );
        }
      } else {
        if (obj.type === controlType.DatePicker) {
          componentToBeRendered = (
              <div className={`col-xs-${obj.fieldWidth}`}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container>
                      <KeyboardDatePicker
                          minDate = {obj.minDate}
                          disabled={!data.isEditable}
                          margin="normal"
                          error={otData[ind]['Is' + obj.key]}
                          helperText={otData[ind][obj.key + 'errorMessage']}
                          id="date-picker-dialog"
                          label={<><span>{obj.displayName}</span> {obj.isRequired ? <span className="error-text">*</span> : ''} </>}
                          format="MM/dd/yyyy"
                          name={obj.key}
                          value={data[obj.key]}
                          onChange={(e) => this.onChangeValues(e, obj, ind)}
                          KeyboardButtonProps={{
                            'aria-label': 'change date'
                          }}
                          className="w-100"
                          InputProps={{ readOnly: true }}
                      />
                      </Grid>
                  </MuiPickersUtilsProvider>
               </div>
          );
        } else if (obj.type === controlType.DropDown) {
          componentToBeRendered = (
              <div className={`col-xs-${obj.fieldWidth}`}>
                   <Autocomplete
                      blurOnSelect
                      disabled={!data.isEditable}
                      id="tags-standard"
                      error={otData[ind]['Is' + obj.key]}
                      helperText={otData[ind][obj.key + 'errorMessage']}
                      onChange={(e, val) => this.onChangeValues(val, obj, ind)}
                      options={obj.filterBy !== undefined && otData[ind][obj.filterBy] > 0 ? dropDown.source.filter(x => x[obj.filterBy] === otData[ind][obj.filterBy]) : dropDown.source}
                      getOptionLabel={(option) => option[dropDown.key]}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label={<><span>{obj.displayName}</span> {obj.isRequired ? <span className="error-text">*</span> : ''} </>}
                          error={otData[ind]['Is' + obj.key]}
                          helperText={otData[ind][obj.key + 'errorMessage']}
                        />
                      )}
                      value = {data[obj.key]}
                    />
               </div>
          );
        } else if (obj.type === controlType.TextBox) {
          componentToBeRendered = (
            <>
            <div className={`col-xs-${obj.fieldWidth}` + (obj.key === 'comments' ? ' comment-container' : '')}>
                  <TextField
                  className={obj.key === 'comments' ? 'comment-text' : ''}
                  // InputProps={inpProps}
                  disabled={!data.isEditable}
                  error={otData[ind]['Is' + obj.key]}
                  helperText={otData[ind][obj.key + 'errorMessage']}
                  value= {obj.key === 'payDate' ? moment(data[obj.key]).format('MM/DD/YYYY') : data[obj.key] || ''}
                  fullWidth
                  name={obj.key}
                  margin="normal"
                  size="small"
                  color="primary"
                  // label={<><span>{obj.displayName}</span> {(disableTextField || obj.isRequired)} ? <span className="error-text">*</span> : '')} </>}
                  InputLabelProps={{ shrink: true }}
                  label={<><span>{obj.displayName}</span> {(obj.isRequired || disableTextField) ? (!disableTextField ? <span className="error-text">*</span> : '') : ''} </>}
                  onChange={(e) => this.onChangeValues(e.target.value, obj, ind)}
                  inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                  />
               {obj.key === 'comments' && !data.isEditable && <>
               <Button
                          disabled={!data.isEditable}
                          variant="contained"
                          color="primary"
                          size="small"
                          startIcon={ <AddIcon fontSize="small" size="small" />}
                          onClick={() => {
                            this.AddNewRow(configuration, ind);
                          }}
                        >
                          Split
                  </Button>
                  &nbsp;&nbsp;
                  {(otData || []).filter(xd => xd.otDate === data.otDate).length > 1 &&
                  <Button
                          disabled={!data.isEditable}
                          variant="contained"
                          color="primary"
                          size="small"
                          startIcon={ <CancelIcon fontSize="small" size="small" />}
                          onClick={() => {
                            this.removeOt(ind);
                          }}
                        >
                          Remove
                  </Button>}
               </>}
               </div>
          </>

          );
        }
      }

      // else if (obj.type === controlType.Button) { // && obj.operator === 'Equal') { // && ind === 0) {
      //   componentToBeRendered = (
      //       <div className='col-xs-3'>
      //           <Button
      //                   variant="contained"
      //                   color="primary"
      //                   size="small"
      //                   startIcon={ <AddIcon fontSize="small" size="small" />}
      //                   onClick={() => {
      //                     this.AddNewRow(configuration, ind);
      //                   }}
      //                 >
      //                   Split
      //           </Button>
      //           &nbsp;&nbsp;
      //           {(otData || []).filter(xd => xd.otDate === data.otDate).length > 1 &&
      //           <Button
      //                   variant="contained"
      //                   color="primary"
      //                   size="small"
      //                   startIcon={ <CancelIcon fontSize="small" size="small" />}
      //                   onClick={() => {
      //                     this.removeOt(ind);
      //                   }}
      //                 >
      //                   Remove
      //           </Button>}
      //       </div>
      //   );
      // }
      // else if (obj.type === controlType.Button &&
      //   obj.operator === 'Greater Than' && otData?.length > 1 &&
      //   (otData || []).filter(xd => xd.otDate === data.otDate).length > 1) {
      //   componentToBeRendered = (
      //       <div className='col-xs-1'>
      //           <Button
      //                   variant="contained"
      //                   color="primary"
      //                   size="small"
      //                   startIcon={ <CancelIcon fontSize="small" size="small" />}
      //                   onClick={() => {
      //                     this.removeOt(ind);
      //                   }}
      //                 >
      //                   Remove
      //           </Button>
      //       </div>
      //   );
      // }
      return (
        componentToBeRendered
      );
    }

    SaveMultipleOvertimeAttendance = (formFields) => {
      const { otData, selectedData, originalOtData, hoursOtData, uniqueDates } = this.state;
      const selectedEmployee = selectedData.find((x) => x.key === 'employeeName') || {};
      const employeeEmail = selectedEmployee?.email;
      const totalOriginalHours = this.state.otHrs;
      const totalOriginalRegular = this.state.otReg;
      const totalOtHours = this.getTotalHours(otData, 'ot');
      const totalRegHour = this.getTotalHours(otData, 'reg');
      const otZeroFlag = (totalOriginalHours !== 0) && (totalOtHours === 0);
      const regZeroFlag = (totalOriginalRegular !== 0) && (totalRegHour === 0);
      // if (otZeroFlag || regZeroFlag) {
      //   if (otZeroFlag && regZeroFlag) {
      //     ShowToast(
      //       `Total adjusted OT Hours(${totalOriginalHours}) and Additional Reg Hours(${totalOriginalRegular})
      //        cannot be 0.`,
      //       toastType.ERROR,
      //       5000,
      //       500
      //     );
      //   } else if (otZeroFlag) {
      //     ShowToast(
      //       `Total adjusted OT Hours(${totalOtHours})
      //        cannot be 0.`,
      //       toastType.ERROR,
      //       5000,
      //       500
      //     );
      //   } 
      //   else if (regZeroFlag) {
      //     ShowToast(
      //       `Total adjusted Additional Reg Hours(${totalOriginalRegular})
      //        cannot be 0.`,
      //       toastType.ERROR,
      //       5000,
      //       500
      //     );
      //   }
      //   return;
      // }
      if (otData.find(x => x.isInErrorState === true ||
        x.IspropertyName === true ||
        x.IsotHours === true ||
        x.IsadditionalRegHours === true) !== undefined) {
        const otData1 = this.validateForm(otData, formFields);
        this.setState({ otData: otData1 }, () => { this.forceUpdate(); });
        return;
      }
      const otData1 = this.validateForm(otData, formFields);
      if (otData1.find(x => x.isInErrorState === true ||
        x.IspropertyName === true ||
        x.IsotHours === true ||
        x.IsadditionalRegHours === true) !== undefined) {
        this.setState({ otData: otData1 }, () => { this.forceUpdate(); });
        return;
      }
      // const otFlag = totalOriginalHours === totalOtHours;
      const otFlag = totalOtHours <= totalOriginalHours;
      // const addRegFlag = totalOriginalRegular <= totalRegHour;
      const addRegFlag = totalRegHour <= totalOriginalRegular;
      // if (submitRegFlag) {
      // console.log(subMitOtFlag);
      if (otFlag && addRegFlag) {
        const selectedEmployee = selectedData.find((x) => x.key === 'employeeName') || {};

        const periodStartDate = selectedData.find(x => x.key === 'payCycle').selected.startDate;
        const periodEndDate = selectedData.find(x => x.key === 'payCycle').selected.endDate;
        otData.map(ot => {
          ot.hours = parseFloat(ot.otHours) || 0;
          ot.otHours = parseFloat(ot.otHours) || 0;
          ot.marketId = ot.marketName.marketId;
          ot.propertyId = ot.propertyName.propertyId;
          ot.marketName = ot.marketName.marketName;
          ot.propertyName = ot.propertyName.propertyName;
          ot.payDate = moment(ot.payDate).format('YYYY/MM/DD');
          ot.employeeId = selectedEmployee?.selected?.employeeId || 0;
          ot.employeeEmail = selectedEmployee?.selected?.email || null;
          ot.additionalRegHours = parseFloat(ot.additionalRegHours) || 0;
          ot.periodStartDate = moment(periodStartDate).format('YYYY/MM/DD');
          ot.periodEndDate = moment(periodEndDate).format('YYYY/MM/DD');
          // ot.employeeName = ot.employeeName.employeeName;
          ot.otDate = moment(ot.otDate).format(
            'YYYY/MM/DD'
          );
          return ot;
        });
        this.SaveOvertimeAttendance(otData);
      } else {
        if (otFlag === false && addRegFlag === false) {
          ShowToast(
              `Total adjusted OT Hours(${totalOtHours}) and Additional Reg Hours(${totalRegHour}) must be less then or equal to UltiPro registered OT Hours(${totalOriginalHours}) and Additional Reg Hours (${totalOriginalRegular}).`,
              toastType.ERROR,
              5000,
              500
          );
        } else if (otFlag === false) {
          ShowToast(
            `Total adjusted OT Hours(${totalOtHours}) must be less then or equal to UltiPro registered OT Hours(${totalOriginalHours}).`,
            toastType.ERROR,
            5000,
            500
          );
        } else if (addRegFlag === false) {
          ShowToast(
            `Total adjusted Additional Reg Hours(${totalRegHour}) must be less then or equal to UltiPro registered  Additional Reg Hours (${totalOriginalRegular}).`,
            toastType.ERROR,
            5000,
            500
          );
        }
      }
    }

    getTotalHours = (arr, type = 'ot') => {
      let a = 0;
      if (type === 'ot') {
        arr.forEach(x => {
          a = a + (parseFloat(x.otHours) || 0);
        });
      } else if (type === 'reg') {
        arr.forEach(x => {
          a = a + (parseFloat(x.additionalRegHours) || 0);
        });
      }

      return a;
    }

    SaveOvertimeAttendance = (otData, isMessage = 0) => {
      const employeeOvertimeDataStore = [...(this.state.employeeOvertimeData || [])];
      const { selectedData, isForDelete } = this.state;
      const selectedEmployee = selectedData.find((x) => x.key === 'employeeName') || {};
      const empId = selectedEmployee?.selected?.employeeId || 0;

      const periodStartDate = selectedData.find(x => x.key === 'payCycle').selected.startDate;
      const periodEndDate = selectedData.find(x => x.key === 'payCycle').selected.endDate;
      const otData1 = [{
        employeeOvertimeId: 0,
        approvalStatusId: 3,
        statusId: 1,
        employeeEmail: (((store.getState() || {}).auth || {}).account || {}).userName || '',
        periodStartDate: periodStartDate,
        periodEndDate: periodEndDate,
        otHours: null,
        marketId: 0,
        marketName: null,
        propertyId: null,
        propertyName: null,
        otDate: null,
        comments: null,
        isInErrorState: false,
        payDate: null,
        employeeId: 0

      }];
      apiPut(API_URL.Employee.SaveEmployeeOvertime, otData, { isForDelete })
        .then(({ data: response }) => {
          if (response.success === true) {
            if (isMessage === 0) {
              this.setState({
                submittedData: true,
                totalDays: 0
              });
              ShowToast(
                'Record(s) added successfully.',
                toastType.SUCCESS,
                5000,
                500
              );
            //  this.SaveEmployeeOTAdjustment(periodStartDate, periodEndDate, empId, employeeOvertimeDataStore, otData1);
            } else if (isMessage === 1) {
              ShowToast(
                'Record(s) deleted successfully.',
                toastType.SUCCESS,
                5000,
                500
              );
              // this.getOvertimeData(periodStartDate, periodEndDate, empId, employeeOvertimeDataStore, otData1);
            } else if (isMessage === 2) {
              ShowToast(
                'Record(s) updated successfully.',
                toastType.SUCCESS,
                5000,
                500
              );
              // this.SaveEmployeeOTAdjustment(periodStartDate, periodEndDate, empId, employeeOvertimeDataStore, otData1);
            }
            this.getOvertimeData(periodStartDate, periodEndDate, empId, employeeOvertimeDataStore, otData1);
          } else {
            ShowToast(
              response.msg,
              toastType.ERROR,
              5000,
              500
            );
          }
        }).catch(() => {
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            false,
            500
          );
        });
    }

  SaveEmployeeOTAdjustment = (periodStartDate1, periodEndDate1, empId, employeeOvertimeDataStore, otData1) => {
    const { selectedData } = this.state;
    const payDate = selectedData.find(x => x.key === 'payCycle').selected.payDate;
    const periodStartDate = moment(getCurrentPayCycleStartDateByDate(payDate)).format('MM/DD/YYYY');
    const periodEndDate = moment(getCurrentPayCycleEndDateByDate(payDate)).format('MM/DD/YYYY');

    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetReimbursementAdjustmentDetail + '?periodStartDate=' + periodStartDate + '&periodEndDate=' + periodEndDate + '&employeeId=' + empId + '&showDetail=' + true + '&adjustmentType=' + 'Property OT',
        key: 'employeeDetails'
      }
    ])
      .then(({ employeeDetails }) => {
        const mergedArray = [];
        employeeDetails.data.filter(x => x.payCodeTypeId !== 4).map(x => {
          x.billingAccountingAdjustment.map(y => {
            let adjustmentObj = [];
            adjustmentObj = y;
            adjustmentObj.reimbursementAmount = adjustmentObj.reimbursementAmount !== undefined && adjustmentObj.reimbursementAmount !== null && adjustmentObj.reimbursementAmount !== '' ? adjustmentObj.reimbursementAmount : 0;
            adjustmentObj.splitPercent = adjustmentObj.splitPercent !== undefined && adjustmentObj.splitPercent !== null && adjustmentObj.splitPercent !== '' ? adjustmentObj.splitPercent : 0;
            adjustmentObj.employeeId = x.employeeId;
            adjustmentObj.employeeName = x.employeeName;
            adjustmentObj.allocationPercent = x.allocationPercent;
            adjustmentObj.adjustmentPercent = x.adjustmentPercent;
            adjustmentObj.grossAmount = x.grossAmount;
            adjustmentObj.periodEndDate = x.periodEndDate;
            adjustmentObj.periodStartDate = x.periodStartDate;
            adjustmentObj.splitType = 'Amount Split';
            adjustmentObj.propertyId = x.propertyId;
            adjustmentObj.propertyName = x.propertyName;
            adjustmentObj.Multiplier = x.Multiplier;
            mergedArray.push(adjustmentObj);
            return y;
          });
          return x;
        });
        this.SaveReimbursementAdjustment(mergedArray, periodStartDate1, periodEndDate1, empId, employeeOvertimeDataStore, otData1);
      })
      .catch(() => { });
  }

  SaveReimbursementAdjustment = (adjustmentData, periodStartDate, periodEndDate, empId, employeeOvertimeDataStore, otData1) => {
    apiPut(API_URL.Employee.SaveReimbursementAdjustment, adjustmentData, {
      adjustmentType: 'Property OT'
    }).then(({ data: response }) => {
      this.getOvertimeData(periodStartDate, periodEndDate, empId, employeeOvertimeDataStore, otData1);
    }).catch(() => {
    });
  }

  getOvertimeDataObject = (element, otSumTotal, regularSum, payCycle, payCycleStart, payCycleEnd, selectedEmployee, payDate) => {
    const otSum = parseFloat(element.overt1); // + parseFloat(element.overt2) + parseFloat(element.overt3) + parseFloat(element.overt4) + parseFloat(element.overt5);
    // const isAdditional = element.paycodeId === 12;
    otSumTotal = otSumTotal + otSum;
    regularSum = regularSum + parseFloat(element.overt2); // (isAdditional === true ? otSum : 0);
    const obj = {
      employeeOvertimeId: 0,
      approvalStatusId: 3,
      statusId: 1,
      otDate: moment(element.workDate).format('MM/DD/YYYY'),
      otHours: otSum, // === 0 || isAdditional === true ? 0 : otSum,
      additionalRegHours: parseFloat(element.overt2), // (isAdditional === true ? otSum : 0),
      marketId: selectedEmployee?.selected?.marketId,
      marketName: { marketId: selectedEmployee?.selected?.marketId, marketName: selectedEmployee?.selected?.marketName },
      propertyId: null,
      propertyName: null,
      comments: null,
      isInErrorState: false,
      employeeId: selectedEmployee?.selected?.employeeId,
      employeeName: selectedEmployee?.selected?.employeeName,
      periodStartDate: moment(payCycleStart).format('MM/DD/YYYY'), // : date[1],
      periodEndDate: moment(payCycleEnd).format('MM/DD/YYYY'), // : date[0],
      payDate: moment(payDate).format('MM/DD/YYYY')

    };
    return obj;
  }

     handleTableEditChange = (value, fieldName) => {
       const { employeeOvertimeColumn } = this.state;
       const param = { ...this.state.updateData };

       param[fieldName] = value;

       isGridFormValid(value, employeeOvertimeColumn.find(x => x.key === fieldName), param);

       this.setState({ updateData: param, employeeOvertimeColumn }, () => {
         this.forceUpdate();
       });
     };

     Clear = () => {
       const { originalOtData, hoursOtData } = this.state;
       originalOtData.forEach(x => {
         const one = hoursOtData.dates.filter(y => y.key === x.otDate);
         let otSum = 0;
         let regSum = 0;
         one.forEach(yy => {
           otSum = otSum + yy.totalOtHours;
           regSum = regSum + yy.additionalRegHoursSum;
         });
         x.otHours = otSum;
         x.additionalRegHours = regSum;
         x.comments = '';
       });
       this.setState({
         otData: [...originalOtData.filter(x => x.otHours > 0 || x.additionalRegHours > 0)],
         isEditableMode: false,
         selectedEditRowId: undefined,
         isInAddMode: false,
         updateData: undefined,
         isPopupOpen: false,
         confirmationMessage: '',
         submittedData: false
       }, () => { this.forceUpdate(); });
     }

     onFilterChange = (selectedData, inEditMode = false) => {
       const selectedEmployee = selectedData.find((x) => x.key === 'employeeName') || {};
       const periodStartDate = selectedData.find(x => x.key === 'payCycle').selected.startDate;
       const periodEndDate = selectedData.find(x => x.key === 'payCycle').selected.endDate;
       const payCycle = selectedData.find(x => x.key === 'payCycle').selected.payCycle;
       const payDate = moment(selectedData?.find(x => x.key === 'payCycle')?.selected?.payDate).format('MM/DD/YYYY') || null;
       this.setState({ selectedData, isClosed: selectedData.find(x => x.key === 'payCycle').selected.isClosed });

       let eId;
       let employeeId = '';
       if (
         selectedEmployee &&
        selectedEmployee.selected
       ) {
         employeeId = this.getFormattedData(selectedEmployee.selected.ultiProEmployeeNumber) + '-' + selectedEmployee.selected.companyId;
         eId = selectedEmployee.selected.employeeId;
       }

       this._asyncRequest = apiBatchRequest([{
         url: API_URL.UltiProService.GetWorkHoursByEmployeeId + '?employeeId=' + employeeId + '&startDate=' + periodStartDate + '&endDate=' + periodEndDate,
         key: 'employeeOtHours'
       },
       {
         url: API_URL.Employee.GetEmployeeOvertimeDetail + '?periodStartDate=' + periodStartDate + '&periodEndDate=' + periodEndDate + '&employeeId=' + (eId || 0),
         key: 'employeeOvertimeData'
       },
       {
         url: API_URL.Employee.GetUltiProOvertimeScheduleDetails + '?year=' + moment().year(),
         key: 'overtimeScheduleDetails'
       }
       ])
         .then(({ employeeOtHours, employeeOvertimeData, overtimeScheduleDetails }) => {
           //  console.log(employeeOtHours);
           let showForm = false;
           const OverTimeData = cloneDeep(employeeOtHours?.data || []);
           const OverTimeDataOriginal = cloneDeep(employeeOtHours?.data || []);
           const OverTimeAllocationData = cloneDeep(employeeOvertimeData?.data || []);
           //  showForm = employeeOvertimeData?.data.length > 0;
           let otHrs = 0;
           let otReg = 0;
           const originalOtData = [];
           OverTimeDataOriginal.forEach(x => {
             const otSum = parseFloat(x.overt1);
             const regHrs = parseFloat(x.overt2);
             otHrs = otHrs + otSum;
             otReg = otReg + regHrs;
             originalOtData.push(this.getOvertimeDataObject(x, otSum, regHrs, payCycle, periodStartDate, periodEndDate, selectedEmployee, payDate));
           });
           const ultiproOtSum = otHrs;
           const ultiproAddSum = otReg;
           const otData = [];
           let otSumTotal = 0;
           let regularSum = 0;
           let uniqueDates;// = [...new Set(otData.filter(x => x.otHours > 0 || x.additionalRegHours > 0).map(item => item.otDate))];
           const hoursOtData = {
             dates: []
           };
           OverTimeData.forEach(element => {
             const otSum = parseFloat(element.overt1); // + parseFloat(element.overt2) + parseFloat(element.overt3) + parseFloat(element.overt4) + parseFloat(element.overt5);
             // const isAdditional = element.paycodeId === 12;
             otSumTotal = otSumTotal + parseFloat(element.overt1);
             regularSum = regularSum + parseFloat(element.overt2); // + (isAdditional === true ? otSum : 0);
             hoursOtData.dates.push({
               key: moment(element.workDate).format('MM/DD/YYYY'),
               totalOtHours: parseFloat(otSum),
               additionalRegHoursSum: parseFloat(element.overt2)
             }
             );
           });
           let originalHoursOtData;
           const isClosed = selectedData.find(x => x.key === 'payCycle').selected.isClosed;
           if ((eId || 0) > 0) {
             if (isClosed === false && employeeOtHours.data !== null && employeeOtHours.data.length > 0 && ((employeeOvertimeData || []).data || []).length <= 0) {
               showForm = true;
               let otSumTotal = 0;
               let regularSum = 0;
               OverTimeData.forEach(element => {
                 const otSum = parseFloat(element.overt1); // + parseFloat(element.overt2) + parseFloat(element.overt3) + parseFloat(element.overt4) + parseFloat(element.overt5);
                 // const isAdditional = element.paycodeId === 12;
                 otSumTotal = otSumTotal + otSum;
                 regularSum = regularSum + parseFloat(element.overt2); // + (isAdditional === true ? otSum : 0);
                 otData.push(this.getOvertimeDataObject(element, otSumTotal, regularSum, payCycle, periodStartDate, periodEndDate, selectedEmployee, payDate));
                 _.orderBy(otData, ['otDate'], ['asc']);
               });
               originalHoursOtData = { ...hoursOtData?.dates?.filter(x => x.totalOtHours > 0 || x.additionalRegHoursSum > 0) };
               //  uniqueDates = [...new Set(hoursOtData?.dates?.filter(x => x.otHours > 0 || x.additionalRegHours > 0).map(item => item.otDate))];
             } else {
               showForm = false;
               OverTimeAllocationData.forEach(
                 ot => {
                   const obj = cloneDeep(ot);
                   obj.marketName = { ...this.state.marketMasterData.find(xm => xm.marketName === ot.marketName) };
                   obj.propertyName = { ...this.state.propertyMasterData.find(xm => xm.propertyName === ot.propertyName) };
                   obj.otDate = moment(ot.otDate).format('MM/DD/YYYY');
                   otSumTotal += obj.otHours;
                   regularSum += obj.additionalRegHours;
                   otData.push({ ...obj });
                 }
               );
               OverTimeData.forEach(element => {
                 if (otData.find(xt =>
                   moment(xt.otDate).format('MM/DD/YYYY') === moment(element.workDate).format('MM/DD/YYYY')) === undefined) {
                   otData.push(this.getOvertimeDataObject({ ...element }, otSumTotal, regularSum, payCycle, periodStartDate, periodEndDate, selectedEmployee, payDate));
                   const otSum = parseFloat(element.overt1); // + parseFloat(element.overt2) + parseFloat(element.overt3) + parseFloat(element.overt4) + parseFloat(element.overt5);
                   // const isAdditional = element.paycodeId === 12;
                   otSumTotal = otSumTotal + otSum;
                   regularSum = regularSum + parseFloat(element.overt2); // (isAdditional === true ? otSum : 0);
                 }
               });
             }
           }
           _.orderBy(otData, ['otDate'], ['asc']);
           function compare (a, b) {
             if (a.otDate < b.otDate) {
               return -1;
             }
             if (a.otDate > b.otDate) {
               return 1;
             }
             return 0;
           }
           otData.sort(compare);
           const sortEmployeeOvertimeData = employeeOvertimeData?.data?.sort(compare) || [];

           const noOfDays = [...new Set(otData.filter(x => x.otHours > 0 || x.additionalRegHours > 0).map(item => item.otDate))].length;
           uniqueDates = [...new Set(otData.filter(x => x.otHours > 0 || x.additionalRegHours > 0).map(item => {
             return { key: item.otDate };
           }
           ))];
           const uniqueDatesFromOriginal = originalOtData.filter(x => x.otHours > 0 || x.additionalRegHours > 0).map(x => x.otDate);
           const arr = [];
           otData.forEach(x => {
             uniqueDatesFromOriginal.forEach(y => {
               if (y === x.otDate) {
                 arr.push(x);
               }
             });
           });

           if (isClosed === true) {
             ShowToast(
               "Selected pay period is closed. You can't adjust the values.",
               toastType.INFO,
               5000,
               500);
           }
           this.setState({
             payCycle: (this.state.originalPayCycleData.find(x => x.payCycle === payCycle) || {}),
             payCycleData: cloneDeep(this.state.originalPayCycleData),
             selectedData,
             selectedEditRowId: undefined,
             isInAddMode: false,
             updateData: undefined,
             isInCurrentPayCycle: isDateInCurrentPayCycle(moment(periodStartDate).format(DateFormat)),
             employeeOtData: cloneDeep(employeeOtHours.data),
             otData: inEditMode ? arr : (otData.length > 0 ? otData.filter(x => parseFloat(x.otHours) > 0 || parseFloat(x.additionalRegHours) > 0) : []),
             employeeOvertimeData: cloneDeep(sortEmployeeOvertimeData),
             searched: (eId !== undefined),
             otSumTotal,
             regularSum,
             totalDays: inEditMode ? originalOtData.filter(x => x.otHours > 0 || x.additionalRegHours > 0).length : noOfDays,
             showSubmitAndClear: otData.length > 0,
             originalOtData: originalOtData.filter(x => x.otHours > 0 || x.additionalRegHours > 0),
             hoursOtData, // : hoursOtData.dates.filter(x => x.totalOtHours > 0 || x.additionalRegHoursSum > 0),
             originalHoursOtData,
             uniqueDates,
             OverTimeDataOriginal,
             otHrs,
             otReg,
             showForm,
             periodStartDate,
             periodEndDate,
             ultiproAddSum,
             ultiproOtSum,
             inEditMode: isClosed === true ? false : inEditMode,
             submittedData: false,
             //  originalOvertime: otData.filter(x => x.otHours > 0)
             isClosed: isClosed
           });
         })
         .catch(() => { });
     }

  getOvertimeData = (periodStartDate, periodEndDate, empId, employeeOvertimeDataStore, otData1) => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeOvertimeDetail + '?periodStartDate=' + periodStartDate + '&periodEndDate=' + periodEndDate + '&employeeId=' + empId,
        key: 'employeeOvertimeData'
      }
    ])
      .then(({ employeeOvertimeData }) => {
        this.setState({
          otData: otData1,
          isEditableMode: false,
          inEditMode: false,
          employeeOvertimeData: employeeOvertimeData.data,
          configuration: employeeOvertimeData.config || [],
          selectedEditRowId: undefined,
          isInAddMode: false,
          updateData: undefined,
          isPopupOpen: false,
          confirmationMessage: '',
          otSumTotal: 0,
          regularSum: 0,
          totalDays: 0,
          isForDelete: false
        }, () => { this.forceUpdate(); });
      })
      .catch(() => {
        this._asyncRequest = null;
        this.setState({
          otData: otData1,
          allocationData: employeeOvertimeDataStore,
          selectedEditRowId: undefined,
          isInAddMode: false,
          updateData: undefined
        }, () => { this.forceUpdate(); });
      });
  }

  render () {
    const {
      configuration,
      employeeOvertimeData,
      marketMasterData,
      propertyMasterData,
      payCycleData,
      otData,
      isPopupOpen,
      confirmationMessage,
      employeeOvertimeColumn,
      employeeMasterData,
      searched,
      defaultSelectedData,
      selectedData,
      showForm
    } = this.state;
    const EditSource = [];
    const periodStartDate = selectedData.find(x => x.key === 'payCycle')?.selected.startDate;
    const periodEndDate = selectedData.find(x => x.key === 'payCycle')?.selected.endDate;
    _.orderBy(employeeOvertimeData, '[otDate]', ['asc']);
    _.orderBy(otData, '[otDate]', ['asc']);
    EditSource.push(
      { key: 'marketMasterData', data: marketMasterData },
      { key: 'propertyMasterData', data: propertyMasterData },
      { key: 'employeeMasterData', data: employeeMasterData }
    );

    const formFields = [
      {
        key: 'otDate',
        type: controlType.TextBox,
        shrink: true,
        isEditable: false,
        isVisible: true,
        isRequired: false,
        displayName: 'Work Date',
        minDate: moment(getCurrentPayCycleStartDate()).format(DateFormat),
        disableEdit: true,
        fieldWidth: 1
      },
      {
        key: 'payDate',
        type: controlType.TextBox,
        // minDate: moment(this.state?.selectedData?.find(x => x.key === 'payCycle')?.selected?.payCycleEnd).add(1, 'days'),
        shrink: true,
        isEditable: true,
        isVisible: true,
        isRequired: true,
        displayName: 'Pay Date',
        disableEdit: true,
        fieldWidth: 1,
        dataFormat: 'Date'
      },
      {
        key: 'marketName',
        type: controlType.DropDown,
        shrink: true,
        isEditable: true,
        isVisible: true,
        isRequired: true,
        displayName: 'Market Name',
        idField: 'marketId',
        resetValue: ['propertyName', 'propertyId'],
        fieldWidth: 2
      },
      {
        key: 'propertyName',
        type: controlType.DropDown,
        shrink: true,
        isEditable: true,
        isVisible: true,
        isRequired: true,
        displayName: 'Property Name',
        filterBy: 'marketId',
        filterSourceOn: [
          { key: 'marketId', filterBy: 'marketId' }
        ],
        idField: 'propertyId',
        fieldWidth: 2
      },
      {
        key: 'otHours',
        type: controlType.TextBox,
        shrink: true,
        isEditable: true,
        isVisible: true,
        isRequired: false,
        displayName: 'Hours',
        dataFormat: 'DecimalNumber',
        fieldWidth: 1,
        disabledWhen: {
          value: 0
        }
      },
      {
        key: 'additionalRegHours',
        type: controlType.TextBox,
        shrink: true,
        isEditable: true,
        isVisible: true,
        isRequired: false,
        displayName: 'ADD R Hours',
        dataFormat: 'DecimalNumber',
        fieldWidth: 1,
        disabledWhen: {
          value: 0
        }
      },
      {
        key: 'comments',
        type: controlType.TextBox,
        shrink: true,
        isEditable: true,
        isVisible: true,
        isRequired: false,
        displayName: 'Comment',
        fieldWidth: 4
      }
      // {
      //   type: controlType.Button,
      //   isVisible: true,
      //   displayName: 'Add New',
      //   operator: 'Equal'
      // }
      // {
      //   type: controlType.Button,
      //   isVisible: true,
      //   displayName: 'Remove',
      //   operator: 'Greater Than'
      // }
    ];

    const dropDownSource = [
      {
        key: 'marketName',
        option: 'marketName',
        idField: 'marketId',
        source: marketMasterData
      },
      {
        key: 'propertyName',
        option: 'propertyName',
        idField: 'propertyId',
        source: propertyMasterData
      }
    ];

    console.log(this.state.inEditMode, showForm);

    return (
      <>
        {(
            <>
             {isPopupOpen && (
                <ConfirmDialog
                    IsOpen={isPopupOpen}
                    Message={confirmationMessage}
                    OnHandelClick={(isValid) => {
                      if (isValid) {
                        this.onPopupClickHandle(isValid);
                      } else {
                        this.onPopupClickHandle(isValid);
                      }
                    }}
                    AgreeText="Yes"
                    DisAgreeText="No"
                />
             )}

              {(<PageHeader title="Overtime Attendance Sheet"></PageHeader>)}
              <PageFilter
          autoFilter={false}
          filterAlwaysVisible={true}
          onFilterChanged={this.onFilterChange}
          hidePanel={true}
          filterConfig={[
            {
              multiple: false,
              type: controlType.DropDown,
              source: employeeMasterData,
              key: 'employeeName',
              placeholder: 'Search Employee',
              title: 'Employee',
              disableClearable: false
            },
            {
              multiple: false,
              type: controlType.DropDown,
              source: payCycleData,
              key: 'payCycle',
              placeholder: 'Timesheet Period',
              title: 'Timesheet Period',
              ignoreSort: true,
              disableClearable: true
            }
          ]}
          defaultSelectedData={defaultSelectedData || []}
          selectedData={selectedData}
          gridColumn={3}
        />
             <div className='content ot-box' >
               {(this.state.isClosed === false && this.state.submittedData && <>
                <div className='row form-section' style={{ paddingTop: '10px', paddingBottom: '10px', marginLeft: '1.3rem' }}>
                  <div className='col-xs-12'>
                  <div className='row'>
                  <div className='col-xs-12'>
                    <div className='header-title'>UltiPro Details</div>
                  </div>
                  </div>
                  <div className='row'>

                  <div className='col-xs-12'>
                  Period:&nbsp; <b>{moment(periodStartDate).format('MM/DD/YYYY')} - {moment(periodEndDate).format('MM/DD/YYYY')}</b>
                  &nbsp;Total Days:&nbsp;<b>{this.state.originalOtData.length}</b>
                  &nbsp;Total Over Time Hours:&nbsp;<b> {this.state.ultiproOtSum || 0}</b>
                  &nbsp;Total Additional Regular Hours:&nbsp;<b>{this.state.ultiproAddSum || 0}</b>
                  </div>
                  </div>
                  </div>
                </div></>)}
              {(this.state.isClosed === false && this.state.totalDays > 0) &&
                <div className='row form-section' style={{ paddingTop: '10px', paddingBottom: '10px', marginLeft: '1.3rem' }}>
                  <div className='col-xs-12'>
                  <div className='row'>
                  <div className='col-xs-12'>
                    <div className='header-title'>UltiPro Details</div>
                  </div>
                  </div>
                  <div className='row'>

                  <div className='col-xs-12'>
                  Period:&nbsp; <b>{moment(periodStartDate).format('MM/DD/YYYY')} - {moment(periodEndDate).format('MM/DD/YYYY')}</b>
                  &nbsp;Total Days:&nbsp;<b>{this.state.totalDays}</b>
                  &nbsp;Total Over Time Hours:&nbsp;<b> {this.state.otHrs || 0}</b>
                  &nbsp;Total Additional Regular Hours:&nbsp;<b>{this.state.otReg || 0}</b>
                  </div>
                  </div>
                  </div>
                </div>}
                {/* { isInCurrentPayCycle && */}
                { (this.state.isClosed === false && (employeeOvertimeData === null || employeeOvertimeData?.length === 0 || this.state.inEditMode || showForm)) &&
                <>
                    <div className="row form-section" style={{ paddingTop: '10px', paddingBottom: '10px', marginLeft: '1.3rem' }}>
                    {

                            (propertyMasterData?.length > 0 && otData.length > 0 && this.state.totalDays)
                              ? otData.map((data, ind) => {
                                return (
                            <div className='row col-xs-12' key={ind}>

                                {this.renderForm(UpdateColumnWithConfiguration(formFields, configuration), ind, dropDownSource, data)}
                            </div>);
                              })
                              : <>
                              <div>
                                {searched && otData.length === 0 && this.state.totalDays === 0 && this.state.isClosed === false
                                  ? 'No Overtime record found in UltiPro for the selected employee and timesheet period.'
                                  : ''}</div></>
                        }
                    </div>
                    <div className="col-sm-11 col-sm-offset-1 field-control text-align-r" style={{ marginRight: '12px' }}>
                  {IsSectionVisible(SECTIONS.OVERTIMEATTANDENCESHEET, 0, SECTIONS.ADD_EDIT) && this.state.isClosed === false && this.state.showSubmitAndClear && otData.length > 0 && this.state.totalDays > 0 && (((employeeOvertimeData || [])[0] || {}).isEditable === true ||
                  employeeOvertimeData === undefined || employeeOvertimeData?.length <= 0) && <><Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<SaveIcon />}
                                onClick={() => {
                                  this.SaveMultipleOvertimeAttendance(UpdateColumnWithConfiguration(formFields, configuration));
                                }}
                            >
                                Submit
                            </Button> &nbsp;&nbsp;
                            <Button
                                variant="contained"
                                color="default"
                                size="small"
                                startIcon={<ResetIcon />}
                                onClick={() => {
                                  this.Clear();
                                }}
                            >
                                Clear
                            </Button></>}
                    </div>
                </>
                }
                <div className="row table-list-container">
                    <GridTable
                    columns={UpdateColumnWithConfiguration(employeeOvertimeColumn, configuration)}
                    data={employeeOvertimeData}
                    config={overTimeConfig}
                    selectedEditRowId={this.state.selectedEditRowId}
                    reload={this.state.reloadTable}
                    renderActionColumn={
                        // isInCurrentPayCycle
                          // ?
                          this.renderActionColumn
                          // :
                          // () => {
                          //   return <></>;
                          // }
                          }
                    EditSource={EditSource}
                    isInAddMode={this.state.isInAddMode}
                    handleTableEditChange={this.handleTableEditChange}
                    isEditableMode={this.state.isEditableMode}
                    updateData={this.state.updateData}
                    />
                </div>
             </div>
            </>
        )}
      </>
    );
  }
}

export default EmployeeOvertimeAttendance;
